import React from "react";

const Title = ( props ) => {
  
  return (
    <div className="msync-title">
      <span>{ props.value ?? '' }</span>
    </div>
  )

}

export default Title
